/** 基础相关 如用户信息 **/
const basic = {
  namespaced: true,
  state: {
    userInfo: {
      areaId: "",
      areaName: "",
      businessCompanyName: null,
      businessUserType: null,
      companyName: "",
      customerServiceInfo: {},
      dwmc: "",
      email: "",
      excellentSupplierStarLevel: 0, // 优秀供应商
      expireDate: "",
      isBusinessUser: null,
      isExpired: 0,
      isNewUser: 0,
      isPayBefore: 0,
      isSuperSupplier: 0,
      isUsedCount: 0,
      linkName: "", // 用户姓名 昵称
      maxChildCount: 0,
      memberLevel: 0, // 0 ~ 5：免费用户；6 ~ 20：普通用户；21 ~ 60：VIP
      memberLevelName: "",
      memberOpenTime: "",
      registerTime: "",
      roleId: 0,
      roleName: "",
      sex: "", // m/f
      shouji: "",
      showExpireDate: true,
      types: 0,
      userIcon: "",
      userId: 0,
      userStatus: 0,
      username: "",
      welcomeMsg: "",
      zhiwu: "",

      companyNature: 0, // 单位性质 1:企业单位 2事业单位或事业团体 3个体经营 4个人
      companyArea: "", // 单位业务所在区域
      companyType: "", // 单位类型 1投标企业 2招标采购单位 3厂商 4招标代理机构 5经销商 6服务提供商 7其他
      industry: "", // 行业类型
      product: "", // 主营产品
      contacts: "", // 联系人
      contactNumber: "", // 联系电话
      contactAddress: "", // 联系地址
      mainCustomerGroups: "", // 主要客户群体
      informationTypePreferences: "", // 关注信息类型
    },

    /** 权限统计 **/
    // 灰度功能（后端权限逻辑）
    grayReleaseFeatures: {
      features: [
        // ex:
        // {
        //   code: 'vip-select',
        //   grayRelease: false,
        //   header: []
        // }
      ],
    },
    // 前端权限逻辑
    localAuth: [],

    userGuide: {
      isRangeThreeDay: false,
      newUserFlag: false,
    },
    myApplications: [], // 会员中心 / 菜单 - 全部应用
    isSimulatedLogin: false, // 模拟登录
    isSpider: false, // 是否爬虫访问
    isTwoPointFiveAccount: null, // 是否是2.5账号
    isTwoPointEightAccount: null, // 是否是2.8账号
    industryOptions: [], // 行业分类
  },
  getters: {
    userInfo: (state) => state.userInfo,
    grayReleaseFeatures: (state) => state.grayReleaseFeatures,
    localAuth: (state) => state.localAuth,
    userGuide: (state) => state.userGuide,
    myApplications: (state) => state.myApplications,
    isSimulatedLogin: (state) => state.isSimulatedLogin,
    isSpider: (state) => state.isSpider,
    isTwoPointFiveAccount: (state) => state.isTwoPointFiveAccount,
    isTwoPointEightAccount: (state) => state.isTwoPointEightAccount,
    industryOptions: (state) => state.industryOptions,
  },
  mutations: {
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    updateGrayReleaseFeatures(state, grayReleaseFeatures) {
      state.grayReleaseFeatures = grayReleaseFeatures;
    },
    updateLocalAuth(state, localAuth) {
      state.localAuth = localAuth;
    },
    updateUserGuide(state, userGuide) {
      state.userGuide = userGuide;
    },
    updateMyApplications(state, myApplications) {
      state.myApplications = myApplications;
    },
    updateIsSimulatedLogin(state, isSimulatedLogin) {
      state.isSimulatedLogin = isSimulatedLogin;
    },
    updateIsSpider(state, isSpider) {
      state.isSpider = isSpider;
    },
    updateIsTwoPointFiveAccount(state, isTwoPointFiveAccount) {
      state.isTwoPointFiveAccount = isTwoPointFiveAccount;
    },
    updateIsTwoPointEightAccount(state, isTwoPointEightAccount) {
      state.isTwoPointEightAccount = isTwoPointEightAccount;
    },
    updateIndustryOptions(state, industryOptions) {
      state.industryOptions = industryOptions;
    },
  },
  actions: {},
};
export default basic;
